import generatePicker from "antd/es/date-picker/generatePicker";
import { DateTime } from "luxon";
import luxonGenerateConfig from "./luxonGenerateConfig";
import type { PickerTimeProps } from "antd/es/date-picker/generatePicker";
import "antd/es/date-picker/style/index";
import React from "react";

const BasePicker = generatePicker<DateTime>(luxonGenerateConfig);

export const DateTimePicker = BasePicker;
export const LuxonDatePicker = BasePicker;
export const LuxonTimePicker = React.forwardRef<
  any,
  Omit<PickerTimeProps<DateTime>, "picker">
>((props, ref) => {
  return <BasePicker {...props} picker="time" ref={ref} />;
});

LuxonTimePicker.displayName = "LuxonTimePicker";

export default DateTimePicker;
